import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { OrderRoutingModule } from './order-routing.module';
import { OrderComponent } from './components/order/order.component';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { OrderCatogoryCardModule } from 'src/app/components/modules/order-catogory-card/order-catogory-card.module';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { DateAdapter, MAT_DATE_LOCALE, MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmModule } from 'src/app/dialog/confirm/confirm.module';
import { ImageModule } from 'src/app/components/image/image.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { TicketCardModule } from 'src/app/components/ticket-card/ticket-card.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackbarMessageModule } from 'src/app/components/snackbar-message/snackbar-message.module';
import { OrderHomeComponent } from './components/order-home/order-home.component';
import { OrderViewComponent } from './components/order-view/order-view.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AlertModule } from 'src/app/dialog/alert/alert.module';
import { PaymentStatusDialogModule } from 'src/app/dialog/payment-status-dialog/payment-status-dialog.module';
import { OrderCategoryGroupModule } from 'src/app/components/order-category-group/order-category-group.module';
import { OrderCardInfoModule } from 'src/app/components/order-card-info/order-card-info.module';
import { OrderCardInfoTicketModule } from "../../components/order-card-info-ticket/order-card-info-ticket.module";
import { CustomDateAdapter } from 'src/app/util/custom-date-apter.util';
import { CustomPaginatorIntl } from 'src/app/util/custom-pagination.util';
import { CustomDateSearchAdapter } from 'src/app/util/custom-date-search.util';
import { MethodPaymentModule } from 'src/app/dialog/method-payment/method-payment.module';


@NgModule({
  declarations: [
    OrderComponent,
    OrderHomeComponent,
    OrderViewComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatTableModule,
    MatSelectModule,
    ImageModule,
    MatProgressBarModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatStepperModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    SnackbarMessageModule,
    AlertModule,
    MatPaginatorModule,
    TicketCardModule,
    ConfirmModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatRippleModule,
    MatSortModule,
    MatCheckboxModule,
    TranslateModule,
    OrderCatogoryCardModule,
    PaymentStatusDialogModule,
    OrderRoutingModule,
    OrderCategoryGroupModule,
    OrderCardInfoModule,
    OrderCardInfoTicketModule,
    MethodPaymentModule
],
  providers: [
    // DatePipe,
    { provide: MAT_DATE_LOCALE, useValue: 'en' },
    { provide: DateAdapter, useClass: CustomDateSearchAdapter },
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
  ]
})
export class OrderModule { }
